import type {
  ProductTracker,
  PromotionTracker,
  ElementTracker,
  SectionTracker,
  StreamTracker,
  BasketItemTracker,
  BasketItemTracker_Size,
  PriceTracker,
  BasketTracker,
  SearchTracker,
  BrandTracker,
  FeatureTracker,
  TransactionTracker,
  TransactionTracker_Customer,
  TransactionTracker_Payment,
  TransactionTracker_Item,
  TransactionTracker_Item_AdditionalDataEntry,
  TransactionTracker_Total,
  VariantTracker,
  ProductColorTracker,
} from "../../aysa_api/models/tracker.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseProductTracker = (): ProductTracker => {
  return {
    productId: 0,
    productName: "",
    isSponsored: false,

    isSoldOut: false,
  };
};

export const decodeProductTracker = (
  reader: Reader,
  length: number
): ProductTracker => {
  const end = reader.pos + length;
  const message = createBaseProductTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.productId = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.productName = reader.string();

        break;
      case 3:
        message.isSponsored = reader.bool();

        break;
      case 4:
        message.sponsoredType = reader.string();

        break;
      case 5:
        message.linkTarget = reader.string();

        break;
      case 6:
        message.isSoldOut = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductTracker = (
  writer: Writer,
  message: ProductTracker
): Writer => {
  writer.uint32(8).int64(message.productId);
  writer.uint32(18).string(message.productName);
  writer.uint32(24).bool(message.isSponsored);
  if (message.sponsoredType !== undefined) {
    writer.uint32(34).string(message.sponsoredType);
  }
  if (message.linkTarget !== undefined) {
    writer.uint32(42).string(message.linkTarget);
  }
  writer.uint32(48).bool(message.isSoldOut);

  return writer;
};

export const createBasePromotionTracker = (): PromotionTracker => {
  return {
    promotionId: "",
    promotionName: "",
    creativeName: "",
    creativeSlot: "",
  };
};

export const decodePromotionTracker = (
  reader: Reader,
  length: number
): PromotionTracker => {
  const end = reader.pos + length;
  const message = createBasePromotionTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.promotionId = reader.string();

        break;
      case 2:
        message.promotionName = reader.string();

        break;
      case 3:
        message.creativeName = reader.string();

        break;
      case 4:
        message.creativeSlot = reader.string();

        break;
      case 5:
        message.locationId = reader.string();

        break;
      case 6:
        message.destination = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePromotionTracker = (
  writer: Writer,
  message: PromotionTracker
): Writer => {
  writer.uint32(10).string(message.promotionId);
  writer.uint32(18).string(message.promotionName);
  writer.uint32(26).string(message.creativeName);
  writer.uint32(34).string(message.creativeSlot);
  if (message.locationId !== undefined) {
    writer.uint32(42).string(message.locationId);
  }
  if (message.destination !== undefined) {
    writer.uint32(50).string(message.destination);
  }

  return writer;
};

export const createBaseElementTracker = (): ElementTracker => {
  return {};
};

export const decodeElementTracker = (
  reader: Reader,
  length: number
): ElementTracker => {
  const end = reader.pos + length;
  const message = createBaseElementTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.linkTarget = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeElementTracker = (
  writer: Writer,
  message: ElementTracker
): Writer => {
  if (message.linkTarget !== undefined) {
    writer.uint32(10).string(message.linkTarget);
  }

  return writer;
};

export const createBaseSectionTracker = (): SectionTracker => {
  return {
    name: "",
  };
};

export const decodeSectionTracker = (
  reader: Reader,
  length: number
): SectionTracker => {
  const end = reader.pos + length;
  const message = createBaseSectionTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.name = reader.string();

        break;
      case 2:
        message.linkTarget = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSectionTracker = (
  writer: Writer,
  message: SectionTracker
): Writer => {
  writer.uint32(10).string(message.name);
  if (message.linkTarget !== undefined) {
    writer.uint32(18).string(message.linkTarget);
  }

  return writer;
};

export const createBaseStreamTracker = (): StreamTracker => {
  return {
    sortingChannel: "",
  };
};

export const decodeStreamTracker = (
  reader: Reader,
  length: number
): StreamTracker => {
  const end = reader.pos + length;
  const message = createBaseStreamTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.sortingChannel = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeStreamTracker = (
  writer: Writer,
  message: StreamTracker
): Writer => {
  writer.uint32(10).string(message.sortingChannel);

  return writer;
};

export const createBaseBasketItemTracker = (): BasketItemTracker => {
  return {
    productId: 0,
    url: "",

    key: "",
    isSoldOut: false,
    name: "",
    brand: createBaseBrandTracker(),
    isSponsored: false,
    sponsoredType: "",

    quantity: 0,

    size: createBaseBasketItemTracker_Size(),
  };
};

export const decodeBasketItemTracker = (
  reader: Reader,
  length: number
): BasketItemTracker => {
  const end = reader.pos + length;
  const message = createBaseBasketItemTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.productId = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.url = reader.string();

        break;
      case 3:
        message.masterKey = reader.string();

        break;
      case 4:
        message.key = reader.string();

        break;
      case 5:
        message.isSoldOut = reader.bool();

        break;
      case 6:
        message.name = reader.string();

        break;
      case 7:
        message.brand = decodeBrandTracker(reader, reader.uint32());

        break;
      case 9:
        message.isSponsored = reader.bool();

        break;
      case 10:
        message.sponsoredType = reader.string();

        break;
      case 11:
        message.unitPrice = decodePriceTracker(reader, reader.uint32());

        break;
      case 12:
        message.quantity = (reader.int64() as Long).toNumber();

        break;
      case 13:
        message.totalPrice = decodePriceTracker(reader, reader.uint32());

        break;
      case 14:
        message.size = decodeBasketItemTracker_Size(reader, reader.uint32());

        break;
      case 15:
        message.minPrice = decodePriceTracker(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBasketItemTracker = (
  writer: Writer,
  message: BasketItemTracker
): Writer => {
  writer.uint32(8).int64(message.productId);
  writer.uint32(18).string(message.url);
  if (message.masterKey !== undefined) {
    writer.uint32(26).string(message.masterKey);
  }
  writer.uint32(34).string(message.key);
  writer.uint32(40).bool(message.isSoldOut);
  writer.uint32(50).string(message.name);
  encodeBrandTracker(writer.uint32(58).fork(), message.brand).ldelim();
  writer.uint32(72).bool(message.isSponsored);
  writer.uint32(82).string(message.sponsoredType);
  if (message.unitPrice !== undefined) {
    encodePriceTracker(writer.uint32(90).fork(), message.unitPrice).ldelim();
  }
  writer.uint32(96).int64(message.quantity);
  if (message.totalPrice !== undefined) {
    encodePriceTracker(writer.uint32(106).fork(), message.totalPrice).ldelim();
  }
  encodeBasketItemTracker_Size(
    writer.uint32(114).fork(),
    message.size
  ).ldelim();
  if (message.minPrice !== undefined) {
    encodePriceTracker(writer.uint32(122).fork(), message.minPrice).ldelim();
  }

  return writer;
};

export const createBaseBasketItemTracker_Size = (): BasketItemTracker_Size => {
  return {
    sizeId: 0,
    suppliedId: 0,
    sizeLabel: "",
  };
};

export const decodeBasketItemTracker_Size = (
  reader: Reader,
  length: number
): BasketItemTracker_Size => {
  const end = reader.pos + length;
  const message = createBaseBasketItemTracker_Size();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.sizeId = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.suppliedId = (reader.int64() as Long).toNumber();

        break;
      case 3:
        message.sizeLabel = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBasketItemTracker_Size = (
  writer: Writer,
  message: BasketItemTracker_Size
): Writer => {
  writer.uint32(8).int64(message.sizeId);
  writer.uint32(16).int64(message.suppliedId);
  writer.uint32(26).string(message.sizeLabel);

  return writer;
};

export const createBasePriceTracker = (): PriceTracker => {
  return {
    currencyCode: "",
    price: 0,
    priceWithoutTax: 0,
    fullPrice: 0,
  };
};

export const decodePriceTracker = (
  reader: Reader,
  length: number
): PriceTracker => {
  const end = reader.pos + length;
  const message = createBasePriceTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.currencyCode = reader.string();

        break;
      case 2:
        message.price = (reader.int64() as Long).toNumber();

        break;
      case 3:
        message.priceWithoutTax = (reader.int64() as Long).toNumber();

        break;
      case 4:
        message.fullPrice = (reader.int64() as Long).toNumber();

        break;
      case 5:
        message.saleReduction = (reader.int64() as Long).toNumber();

        break;
      case 6:
        message.campaignReduction = (reader.int64() as Long).toNumber();

        break;
      case 7:
        message.voucherReduction = (reader.int64() as Long).toNumber();

        break;
      case 8:
        message.couponReduction = (reader.int64() as Long).toNumber();

        break;
      case 9:
        message.coinsReduction = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePriceTracker = (
  writer: Writer,
  message: PriceTracker
): Writer => {
  writer.uint32(10).string(message.currencyCode);
  writer.uint32(16).int64(message.price);
  writer.uint32(24).int64(message.priceWithoutTax);
  writer.uint32(32).int64(message.fullPrice);
  if (message.saleReduction !== undefined) {
    writer.uint32(40).int64(message.saleReduction);
  }
  if (message.campaignReduction !== undefined) {
    writer.uint32(48).int64(message.campaignReduction);
  }
  if (message.voucherReduction !== undefined) {
    writer.uint32(56).int64(message.voucherReduction);
  }
  if (message.couponReduction !== undefined) {
    writer.uint32(64).int64(message.couponReduction);
  }
  if (message.coinsReduction !== undefined) {
    writer.uint32(72).int64(message.coinsReduction);
  }

  return writer;
};

export const createBaseBasketTracker = (): BasketTracker => {
  return {
    items: [],
    basketTotalPrice: createBasePriceTracker(),
  };
};

export const decodeBasketTracker = (
  reader: Reader,
  length: number
): BasketTracker => {
  const end = reader.pos + length;
  const message = createBaseBasketTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.items.push(decodeBasketItemTracker(reader, reader.uint32()));

        break;
      case 2:
        message.basketTotalPrice = decodePriceTracker(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBasketTracker = (
  writer: Writer,
  message: BasketTracker
): Writer => {
  for (const value of message.items) {
    encodeBasketItemTracker(writer.uint32(10).fork(), value).ldelim();
  }
  encodePriceTracker(
    writer.uint32(18).fork(),
    message.basketTotalPrice
  ).ldelim();

  return writer;
};

export const createBaseSearchTracker = (): SearchTracker => {
  return {
    searchType: "",
  };
};

export const decodeSearchTracker = (
  reader: Reader,
  length: number
): SearchTracker => {
  const end = reader.pos + length;
  const message = createBaseSearchTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.searchType = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSearchTracker = (
  writer: Writer,
  message: SearchTracker
): Writer => {
  writer.uint32(10).string(message.searchType);

  return writer;
};

export const createBaseBrandTracker = (): BrandTracker => {
  return {
    id: 0,
    name: "",
  };
};

export const decodeBrandTracker = (
  reader: Reader,
  length: number
): BrandTracker => {
  const end = reader.pos + length;
  const message = createBaseBrandTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBrandTracker = (
  writer: Writer,
  message: BrandTracker
): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);

  return writer;
};

export const createBaseFeatureTracker = (): FeatureTracker => {
  return {
    name: "",
  };
};

export const decodeFeatureTracker = (
  reader: Reader,
  length: number
): FeatureTracker => {
  const end = reader.pos + length;
  const message = createBaseFeatureTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.name = reader.string();

        break;
      case 2:
        message.label = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeFeatureTracker = (
  writer: Writer,
  message: FeatureTracker
): Writer => {
  writer.uint32(10).string(message.name);
  if (message.label !== undefined) {
    writer.uint32(18).string(message.label);
  }

  return writer;
};

export const createBaseTransactionTracker = (): TransactionTracker => {
  return {
    orderId: 0,
    items: [],
    total: createBaseTransactionTracker_Total(),
    payments: [],
    carriers: [],
    customer: createBaseTransactionTracker_Customer(),
  };
};

export const decodeTransactionTracker = (
  reader: Reader,
  length: number
): TransactionTracker => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.orderId = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.items.push(
          decodeTransactionTracker_Item(reader, reader.uint32())
        );

        break;
      case 3:
        message.total = decodeTransactionTracker_Total(reader, reader.uint32());

        break;
      case 4:
        message.payments.push(
          decodeTransactionTracker_Payment(reader, reader.uint32())
        );

        break;
      case 5:
        message.carriers.push(reader.string());

        break;
      case 6:
        message.customer = decodeTransactionTracker_Customer(
          reader,
          reader.uint32()
        );

        break;
      case 7:
        message.voucherCode = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker = (
  writer: Writer,
  message: TransactionTracker
): Writer => {
  writer.uint32(8).int64(message.orderId);
  for (const value of message.items) {
    encodeTransactionTracker_Item(writer.uint32(18).fork(), value).ldelim();
  }
  encodeTransactionTracker_Total(
    writer.uint32(26).fork(),
    message.total
  ).ldelim();
  for (const value of message.payments) {
    encodeTransactionTracker_Payment(writer.uint32(34).fork(), value).ldelim();
  }
  for (const value of message.carriers) {
    writer.uint32(42).string(value);
  }
  encodeTransactionTracker_Customer(
    writer.uint32(50).fork(),
    message.customer
  ).ldelim();
  if (message.voucherCode !== undefined) {
    writer.uint32(58).string(message.voucherCode);
  }

  return writer;
};

export const createBaseTransactionTracker_Customer =
  (): TransactionTracker_Customer => {
    return {
      isNewCustomer: false,
      customerId: 0,
    };
  };

export const decodeTransactionTracker_Customer = (
  reader: Reader,
  length: number
): TransactionTracker_Customer => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker_Customer();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.isNewCustomer = reader.bool();

        break;
      case 2:
        message.customerId = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker_Customer = (
  writer: Writer,
  message: TransactionTracker_Customer
): Writer => {
  writer.uint32(8).bool(message.isNewCustomer);
  writer.uint32(16).int64(message.customerId);

  return writer;
};

export const createBaseTransactionTracker_Payment =
  (): TransactionTracker_Payment => {
    return {
      type: "",
      totalWithTax: 0,
    };
  };

export const decodeTransactionTracker_Payment = (
  reader: Reader,
  length: number
): TransactionTracker_Payment => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker_Payment();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 2:
        message.type = reader.string();

        break;
      case 3:
        message.totalWithTax = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker_Payment = (
  writer: Writer,
  message: TransactionTracker_Payment
): Writer => {
  writer.uint32(18).string(message.type);
  writer.uint32(24).int64(message.totalWithTax);

  return writer;
};

export const createBaseTransactionTracker_Item =
  (): TransactionTracker_Item => {
    return {
      productTracker: createBaseProductTracker(),
      variant: createBaseVariantTracker(),
      brandTracker: createBaseBrandTracker(),
      quantity: 0,
      unitPrice: createBasePriceTracker(),
      totalPrice: createBasePriceTracker(),
      carrier: "",
      additionalData: {},
    };
  };

export const decodeTransactionTracker_Item = (
  reader: Reader,
  length: number
): TransactionTracker_Item => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker_Item();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.productTracker = decodeProductTracker(reader, reader.uint32());

        break;
      case 2:
        message.variant = decodeVariantTracker(reader, reader.uint32());

        break;
      case 3:
        message.brandTracker = decodeBrandTracker(reader, reader.uint32());

        break;
      case 4:
        message.quantity = (reader.int64() as Long).toNumber();

        break;
      case 5:
        message.unitPrice = decodePriceTracker(reader, reader.uint32());

        break;
      case 6:
        message.totalPrice = decodePriceTracker(reader, reader.uint32());

        break;
      case 7:
        message.carrier = reader.string();

        break;
      case 8:
        const entry8 = decodeTransactionTracker_Item_AdditionalDataEntry(
          reader,
          reader.uint32()
        );
        message.additionalData[entry8.key] = entry8.value;

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker_Item = (
  writer: Writer,
  message: TransactionTracker_Item
): Writer => {
  encodeProductTracker(
    writer.uint32(10).fork(),
    message.productTracker
  ).ldelim();
  encodeVariantTracker(writer.uint32(18).fork(), message.variant).ldelim();
  encodeBrandTracker(writer.uint32(26).fork(), message.brandTracker).ldelim();
  writer.uint32(32).int64(message.quantity);
  encodePriceTracker(writer.uint32(42).fork(), message.unitPrice).ldelim();
  encodePriceTracker(writer.uint32(50).fork(), message.totalPrice).ldelim();
  writer.uint32(58).string(message.carrier);
  for (const rawKey of Object.keys(message.additionalData)) {
    const key = rawKey;
    encodeTransactionTracker_Item_AdditionalDataEntry(
      writer.uint32(66).fork(),
      {
        key,
        value: message.additionalData[key]!,
      }
    ).ldelim();
  }

  return writer;
};

export const createBaseTransactionTracker_Item_AdditionalDataEntry =
  (): TransactionTracker_Item_AdditionalDataEntry => {
    return {
      key: "",
      value: "",
    };
  };

export const decodeTransactionTracker_Item_AdditionalDataEntry = (
  reader: Reader,
  length: number
): TransactionTracker_Item_AdditionalDataEntry => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker_Item_AdditionalDataEntry();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.key = reader.string();

        break;
      case 2:
        message.value = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker_Item_AdditionalDataEntry = (
  writer: Writer,
  message: TransactionTracker_Item_AdditionalDataEntry
): Writer => {
  writer.uint32(10).string(message.key);
  writer.uint32(18).string(message.value);

  return writer;
};

export const createBaseTransactionTracker_Total =
  (): TransactionTracker_Total => {
    return {
      currencyCode: "",
      price: 0,
      priceWithoutTax: 0,
      fullPrice: 0,
    };
  };

export const decodeTransactionTracker_Total = (
  reader: Reader,
  length: number
): TransactionTracker_Total => {
  const end = reader.pos + length;
  const message = createBaseTransactionTracker_Total();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.currencyCode = reader.string();

        break;
      case 2:
        message.price = (reader.int64() as Long).toNumber();

        break;
      case 3:
        message.priceWithoutTax = (reader.int64() as Long).toNumber();

        break;
      case 4:
        message.fullPrice = (reader.int64() as Long).toNumber();

        break;
      case 5:
        message.saleReduction = (reader.int64() as Long).toNumber();

        break;
      case 6:
        message.campaignReduction = (reader.int64() as Long).toNumber();

        break;
      case 7:
        message.voucherReduction = (reader.int64() as Long).toNumber();

        break;
      case 8:
        message.couponReduction = (reader.int64() as Long).toNumber();

        break;
      case 9:
        message.deliveryCostWithoutTax = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTransactionTracker_Total = (
  writer: Writer,
  message: TransactionTracker_Total
): Writer => {
  writer.uint32(10).string(message.currencyCode);
  writer.uint32(16).int64(message.price);
  writer.uint32(24).int64(message.priceWithoutTax);
  writer.uint32(32).int64(message.fullPrice);
  if (message.saleReduction !== undefined) {
    writer.uint32(40).int64(message.saleReduction);
  }
  if (message.campaignReduction !== undefined) {
    writer.uint32(48).int64(message.campaignReduction);
  }
  if (message.voucherReduction !== undefined) {
    writer.uint32(56).int64(message.voucherReduction);
  }
  if (message.couponReduction !== undefined) {
    writer.uint32(64).int64(message.couponReduction);
  }
  if (message.deliveryCostWithoutTax !== undefined) {
    writer.uint32(72).int64(message.deliveryCostWithoutTax);
  }

  return writer;
};

export const createBaseVariantTracker = (): VariantTracker => {
  return {
    id: 0,
    supplierId: 0,
    sizeLabel: "",
  };
};

export const decodeVariantTracker = (
  reader: Reader,
  length: number
): VariantTracker => {
  const end = reader.pos + length;
  const message = createBaseVariantTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.supplierId = (reader.int64() as Long).toNumber();

        break;
      case 3:
        message.sizeLabel = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeVariantTracker = (
  writer: Writer,
  message: VariantTracker
): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(16).int64(message.supplierId);
  writer.uint32(26).string(message.sizeLabel);

  return writer;
};

export const createBaseProductColorTracker = (): ProductColorTracker => {
  return {
    id: 0,
    name: "",
    slug: "",
  };
};

export const decodeProductColorTracker = (
  reader: Reader,
  length: number
): ProductColorTracker => {
  const end = reader.pos + length;
  const message = createBaseProductColorTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;
      case 3:
        message.slug = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColorTracker = (
  writer: Writer,
  message: ProductColorTracker
): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);
  writer.uint32(26).string(message.slug);

  return writer;
};
